import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ReservationsService } from 'src/app/features/reservations/services/reservations.service';
import Swal from 'sweetalert2';
import { ChangeReservationTable, Floor, FloorItem, ReservationFormResponse } from '../../../../models/Reservation';
import { ChangeTableProblemComponent } from './change-table-problem/change-table-problem.component';
import { Subscription } from 'rxjs';
import { SignalRService } from 'src/app/services/signalR/SignalR.service';
import { SignalEventType } from 'src/app/services/signalR/SignalModel';
import { Lookup } from 'src/app/models/Lookup';

export interface DialogData {
  restaurantId: number,
  reservationId: number,
  floorId: number,
  tablesToSelect: []
}
@Component({
  selector: 'app-change-table',
  templateUrl: './change-table.component.html'
})
export class ChangeTableComponent implements OnInit, OnDestroy {
  loading = false;
  isSubmitted = false;

  floorsLoading = true;
  floorLoading = true;
  floorsList: Lookup[] = [];
  floorId!: number;
  floor!: Floor;

  tablesToSelect = this.data.tablesToSelect || [];
  selectedTables: FloorItem[] = [];
  reservationResponse!: ReservationFormResponse | null;

  canChange = false;
  canViewWaiters = false;

  hardReload = true;
  subscriptions: Subscription[] = [];

  constructor(
    private service: ReservationsService,
    private dialogRef: MatDialogRef<ChangeTableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private translate: TranslateService,
    public dialog: MatDialog,
    private signal: SignalRService
  ) {
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.NewReservation)
        .subscribe(message => { this.signalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.blockTable)
        .subscribe(message => { this.blockTabelSignalAction(message.data); })
    )
  }

  ngOnInit(): void {
    this.floorId = this.data.floorId;
    this.ResFloorsList();
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  signalAction(data: any) {
    if (data.RestaurantId == this.data.restaurantId) {
      this.hardReload = false;
      this.ResFloorsChangeTable();
      this.signal.notify('New reservation added');
    }
  }

  blockTabelSignalAction(data: any) {
    if (data.RestaurantId == this.data.restaurantId) {
      this.hardReload = false;
      this.ResFloorsChangeTable();
    }
  }

  ResFloorsList() {
    this.floorsList = [];
    this.floorsLoading = true;
    this.service.ResFloorsList(this.data.restaurantId).subscribe(
      (data: any) => {
        if (data) {
          this.floorsLoading = false;
          this.floorsList = data;
          if (!this.floorId) { this.floorId = data[0].id; }
          if (this.floorId) {
            this.ResFloorsChangeTable();
          }
        }
      }, err => {
        console.error(err);
      });
  }
  ResFloorsChangeTable(floorId: number = this.floorId) {
    this.floorLoading = true;
    this.floorId = floorId;
    this.service.ResFloorsChangeTable(this.data.reservationId, this.floorId).subscribe(
      (data: any) => {
        this.floorLoading = false;
        this.floor = data.floors[0];
        this.canViewWaiters = data.canViewAssignedWaiter;
        this.hardReload = true;
      }, err => {
        console.error(err);
      });
  }

  CheckReservation() {
    this.canChange = true
    const slectedTablesId = this.selectedTables.map((x: any) => x.id);
    if (JSON.stringify(slectedTablesId) == JSON.stringify(this.tablesToSelect)) {
      this.canChange = false
    }

    this.reservationResponse = null;
    if (
      this.data.reservationId &&
      this.floor?.id &&
      this.selectedTables?.length
    ) {
      this.loading = true;
      let data: ChangeReservationTable = {
        reserveAnyWay: false,
        reservationId: this.data.reservationId,
        floorId: this.floor.id,
        tabels: slectedTablesId
      }
      this.service.ResCheckReservationChangeTable(data).subscribe(response => {
        this.loading = false;
        this.reservationResponse = response;
      }, error => {
        this.loading = false;
      });

    }
  }

  saveTable() {
    this.isSubmitted = true;
    if (!this.selectedTables?.length) return

    this.loading = true;
    let data: ChangeReservationTable = {
      reserveAnyWay: false,
      reservationId: this.data.reservationId,
      floorId: this.floor.id,
      tabels: this.selectedTables.map((x: any) => x.id)
    }

    this.service.ResEditReservationTable(data).subscribe((response: any) => {
      this.loading = false;
      if (response?.result?.success) {
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
        this.dialogRef.close(true);
        this.service.refreshList.next(true);
      } else {
        this.openProblemsDialog(data, response, 1);
      }
    }, error => {
      this.loading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.errors,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    });
  }

  openProblemsDialog(
    reservationData: ChangeReservationTable | null,
    reservationResponse: ReservationFormResponse | null,
    errorType: number
  ) {
    const dialogRef = this.dialog.open(ChangeTableProblemComponent, {
      width: '50rem',
      data: { reservationData, reservationResponse, errorType, view: 'floor' }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);

      if (result) {
        this.dialogRef.close(true);
        this.service.refreshList.next(true);
      }
    });
  }

}
